import { InputHTMLAttributes } from "react";

export type FileType = {
  type: "link" | "file";
  src: string;
  id: number;
  name?: string;
};

export const readImageAsDataURL = (
  file: File
): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = () => {
      reject(reader);
    };
    reader.readAsDataURL(file);
  });
};

export type InputFileType = {
  onChangeFiles: (files: { id: number; file: File }[]) => void;
  defaultFiles: {
    id: number;
    src: string;
  }[];
  watchedFiles: {
    id: number;
    file: File;
  }[];
  deletedFiles: (string | number)[];
  onAddToDeletedFiles?: (ids: number) => void;
  props?: InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>;
  error?: string;
  note?: string;
  allInputsValues?: any;
  disabled?: boolean;
};
